var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYubikey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 63,
    viewBox: "0 0 40 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4.16968,
    width: 26.4153,
    height: 52.8306,
    rx: 2,
    fill: "white",
    stroke: "#236AC9",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.88049,
    y: 5.05005,
    width: 24.6543,
    height: 44.0255,
    rx: 1,
    fill: "#F2FAFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9246,
    y: 3.28906,
    width: 10.5661,
    height: 3.52204,
    rx: 1,
    fill: "#236AC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6588 31.7002C34.1065 31.7002 33.6588 31.2525 33.6588 30.7002L33.6588 25.3039C33.6588 24.7516 34.1065 24.3039 34.6588 24.3039L37.623 24.3039L37.623 31.7002L34.6588 31.7002Z",
    fill: "white",
    stroke: "#236AC9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3602 32.9329C19.4942 32.9329 16.3602 29.7989 16.3602 25.9329L16.3602 24.0712C16.3602 23.5189 16.8079 23.0712 17.3602 23.0712L32.2983 23.0712C32.8505 23.0712 33.2983 23.5189 33.2983 24.0712L33.2983 31.9329C33.2983 32.4851 32.8505 32.9329 32.2983 32.9329L23.3602 32.9329Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33.344C18.6863 33.344 16 30.6577 16 27.344L16 24.6605C16 23.5559 16.8954 22.6605 18 22.6605L31.6588 22.6605C32.7634 22.6605 33.6588 23.5559 33.6588 24.6605L33.6588 31.344C33.6588 32.4486 32.7634 33.344 31.6588 33.344L22 33.344Z",
    stroke: "#236AC9",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 29.0002C22 29.5525 21.5523 30.0002 21 30.0002C20.4477 30.0002 20 29.5525 20 29.0002C20 28.448 20.4477 28.0002 21 28.0002C21.5523 28.0002 22 28.448 22 29.0002Z",
    fill: "#236AC9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16357 34.6665V34.6665C9.16357 39.2863 12.9086 43.0313 17.5284 43.0313H17.9687",
    stroke: "#2EA76D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4467 33.7861V33.7861C13.4467 36.4607 15.6148 38.6289 18.2895 38.6289V38.6289",
    stroke: "#2EA76D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYubikey);
export default __webpack_public_path__ + "static/media/yubikey.336bc7db332fc8d3c2df0e08cd280d9e.svg";
export { ForwardRef as ReactComponent };